import React, {useContext} from "react";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import UiIcon from "../../ui/icons/uiIcon";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import IconButton from "@mui/material/IconButton";
import {createPrompt, getCurrentPrompts, removePrompt, getCurrentPromptParts} from "../aiApi";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {getCommonVisualizerType} from "../../../config";


const UiPopupAIContentPrompts = (props) => {

  const {type} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {promptsList, groupObjects} = uiPopupContext;

  if (!promptsList) {
    return null
  }

  const isActiveType = "isActive" + type;
  const isActiveBody = "partBody" + type;
  const promptsPartsLoading = "promptsPartsLoading" + type;
  const savedPromptPartObject = "savedPromptPartObject" + type;
  const renderPromptsList = promptsList.filter(prObject => prObject.type === type);

  const onCheckboxClick = async (prObject) => {
    uiPopupDispatch({
      promptsList: promptsList.map(groupObject => {
        groupObject[isActiveType] = groupObject.id === prObject.id;
        return groupObject
      }),
      [promptsPartsLoading]: true,
    });
    if (groupObjects) {
      const prPartsResponse = await getCurrentPromptParts(prObject);
      console.log("prPartsResponse", prPartsResponse);
      uiPopupDispatch({
        [promptsPartsLoading]: false,
        groupObjects: groupObjects.map(groupObject => {
          const foundPartForThisPrompt = prPartsResponse.find(prPartObject => {
            return prPartObject.featureGroup === (groupObject.featureGroup.dbName || groupObject.featureGroup.partName);
          });
          groupObject[isActiveBody] = foundPartForThisPrompt ? foundPartForThisPrompt.partBody : "";
          groupObject[savedPromptPartObject] = foundPartForThisPrompt || null;
          return groupObject
        }),
      });
    }
  }

  const onDeleteClick = async (prObject) => {
    uiPopupDispatch({
      promptsList: promptsList.filter(groupObject => {
        return groupObject.id !== prObject.id
      }),
    });
    await removePrompt(prObject);
  }

  const onCreateClick = async () => {
    const newObj = {
      "id": 0,
      "tool": getCommonVisualizerType(),
      "type": type,
      "version": 0,
      "promptBody": "New Prompt"
    }
    await createPrompt(newObj);
    const prompts = await getCurrentPrompts();
    const responseWithId = prompts[prompts.length - 1];
    if (responseWithId) {
      newObj.id = responseWithId.id;
      newObj.version = responseWithId.version;
    }
    uiPopupDispatch({
      promptsList: [...promptsList, newObj],
    });
  }

  return (
    <ul className="ass-list w-full pr-1">
      {renderPromptsList.map(promptObject => {
        return (
          <li key={promptObject.id} className="ass-list__item">
            <div
              className={"ui-checkbox ui-checkbox--small" + (promptObject[isActiveType] ? " ui-checkbox--checked-svg" : "")}
              onClick={() => onCheckboxClick(promptObject)}>
              <div className="ui-checkbox__svg">
                <UiIcon icon="checkmark"/>
              </div>
            </div>
            <div className="ui-checkbox__label flex--center pt-0 pl-025 pr-025 h-full flex--1 flex--start bold color-primary"
                 style={{textAlign: "left", overflow: "hidden", display: "flex"}}
                 onClick={() => onCheckboxClick(promptObject)}>
              Version {promptObject.version}
            </div>
            <IconButton className="look-icon look-icon--small color-red"
                        onClick={() => onDeleteClick(promptObject)}>
              <DeleteForeverIcon/>
            </IconButton>
          </li>
        )
      })}
      <li className="ass-list__item flex flex--center">
        <span className="link link--blue" onClick={onCreateClick}>
            <IconButton className="look-icon look-icon--small">
            <AddCircleOutlineIcon/>
          </IconButton>
          <span>Add New</span>
        </span>
      </li>
    </ul>
  )
};

export default UiPopupAIContentPrompts

